import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  timeAgo: string;
}
export function LiveNotifications() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const purchases: Purchase[] = [{
    name: 'María G.',
    location: 'Miami, FL',
    timeAgo: 'hace 3 minutos'
  }, {
    name: 'Carolina R.',
    location: 'Los Angeles, CA',
    timeAgo: 'hace 5 minutos'
  }, {
    name: 'Ana M.',
    location: 'Houston, TX',
    timeAgo: 'hace 8 minutos'
  }, {
    name: 'Sofia L.',
    location: 'New York, NY',
    timeAgo: 'hace 12 minutos'
  }, {
    name: 'Isabella P.',
    location: 'Chicago, IL',
    timeAgo: 'hace 15 minutos'
  }, {
    name: 'Valentina S.',
    location: 'Phoenix, AZ',
    timeAgo: 'hace 18 minutos'
  }, {
    name: 'Camila T.',
    location: 'San Diego, CA',
    timeAgo: 'hace 22 minutos'
  }, {
    name: 'Lucia V.',
    location: 'Dallas, TX',
    timeAgo: 'hace 25 minutos'
  }];
  useEffect(() => {
    const showNotification = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 3000);
    // Recurring notifications every 20-45 seconds
    const interval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * (45000 - 20000) + 20000);
      setTimeout(showNotification, randomDelay);
    }, 45000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible || !currentPurchase) return null;
  return <div className="fixed bottom-24 left-6 z-50 animate-slide-up" data-id="element-210">
      <div className="bg-white rounded-2xl shadow-2xl p-4 max-w-sm border-l-4 border-emerald-500" data-id="element-211">
        <div className="flex items-start gap-3" data-id="element-212">
          <div className="flex-shrink-0" data-id="element-213">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-cyan-500 rounded-full flex items-center justify-center" data-id="element-214">
              <CheckCircleIcon className="w-6 h-6 text-white" data-id="element-215" />
            </div>
          </div>

          <div className="flex-1 min-w-0" data-id="element-216">
            <p className="text-sm font-semibold text-navy-900" data-id="element-217">
              {currentPurchase.name} compró
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-218">
              Sobrevive a la Quincena
            </p>
            <div className="flex items-center gap-2 mt-2 text-xs text-gray-500" data-id="element-219">
              <span data-id="element-220">📍 {currentPurchase.location}</span>
              <span data-id="element-221">•</span>
              <span data-id="element-222">{currentPurchase.timeAgo}</span>
            </div>
          </div>

          <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-223">
            <XIcon className="w-4 h-4" data-id="element-224" />
          </button>
        </div>
      </div>
    </div>;
}